export const getSatisfactionOption = (data, total, t)=>{
    return {
        tooltip: {
            trigger: 'item',
            formatter: (params)=>{
                const rawName = params.data.rawName || params.name;
                return `${rawName} ${t('c_a_satisfaction_fraction')} : ${params.value} (${params.percent}%)`;
            }
        },
        legend: {
            bottom: 10,
            left: 'center',
            type: 'scroll' /** plain/scroll 平铺or滚动 */ ,
            orient: 'horizontal',
            width: 'auto',
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 12,
            ...{
                itemShape: 'circle' // 不在 TS 类型中，强制加进去,设置 legend 项为圆形
            },
            textStyle: {
                fontSize: 12
            },
            data: data === null || data === void 0 ? void 0 : data.map((item)=>({
                    name: `${item.translatedName || item.name} : ${item.count}`
                }))
        },
        graphic: [
            {
                type: 'text',
                left: '45%',
                top: '46%',
                style: {
                    text: `${t('o_cm_total')}: ${total}`,
                    textAlign: 'center',
                    fontSize: 13
                },
                bounding: 'raw',
                silent: true,
                position: 'center'
            }
        ],
        series: [
            {
                name: 'Access From',
                type: 'pie',
                radius: [
                    '42%',
                    '72%'
                ],
                center: [
                    '50%',
                    '48%'
                ],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 6,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                label: {
                    show: true,
                    position: 'outside',
                    formatter: (params)=>{
                        const rawName = params.data.rawName || params.name;
                        return `${rawName} (${params.percent}%)`;
                    },
                    alignTo: 'labelLine',
                    distanceToLabelLine: 5 // 使文本靠近指示线末端
                },
                labelLine: {
                    show: true,
                    length: 12,
                    length2: 8,
                    smooth: true,
                    lineStyle: {
                        width: 1
                    }
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 16,
                        fontWeight: 'bold'
                    },
                    labelLine: {
                        show: true // 鼠标悬浮时显示指示线
                    }
                },
                data: data === null || data === void 0 ? void 0 : data.map((item)=>({
                        ...item,
                        value: item.count,
                        name: `${item.translatedName || item.name} : ${item.count}`,
                        rawName: item.translatedName || item.name
                    }))
            }
        ]
    };
};
export const getLineOption = (list, t)=>{
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_;
                const yesData = params.find((p)=>p.seriesName === t('c_a_resolve_time'));
                const noData = params.find((p)=>p.seriesName === t('c_a_resolve_one_reception'));
                const yes = (yesData === null || yesData === void 0 ? void 0 : yesData.value) || 0;
                const no = (noData === null || noData === void 0 ? void 0 : noData.value) || 0;
                const yesColor = (yesData === null || yesData === void 0 ? void 0 : yesData.color) || '#9FE080';
                const noColor = (noData === null || noData === void 0 ? void 0 : noData.color) || '#EE6765';
                const name = (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.name;
                /** 计算百分比/避免除以零 */ const total = yes + no;
                const percentYes = total == 0 ? 0 : (yes / total * 100).toFixed(2);
                const percentNo = total == 0 ? 0 : (no / total * 100).toFixed(2);
                let text = `<span style="font-weight:500">${name}</span><br/>
                 <div style="display: flex; align-items: center; margin-bottom: 6px;margin-top: 10px;">
                    <span style="display:inline-block;width:8px;height:8px;margin-right:6px;
                        border-radius:50%; background-color:${noColor}"></span>
                    <span style="font-size:13px">${t('p1_c_unsolved')}： ${no} (${percentNo}%)</span>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 6px;">
                    <span style="display:inline-block;width:8px;height:8px;margin-right:6px;
                        border-radius:50%; background-color:${yesColor}"></span>
                    <span style="font-size:13px">${t('p1_c_solved')}： ${yes} (${percentYes}%)</span>
                </div>`;
                return text;
            }
        },
        grid: {
            top: '8%',
            left: '3%',
            right: '3%',
            bottom: '2%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: list === null || list === void 0 ? void 0 : list.map((item)=>item.name),
                axisTick: {
                    alignWithLabel: true
                },
                axisLabel: {
                    interval: 0,
                    rotate: (list === null || list === void 0 ? void 0 : list.length) > 10 ? 40 : 0,
                    formatter: function(value) {
                        const limit = 4 // 被截断的最大字符数
                        ;
                        return value.length > limit ? value.slice(0, limit) + '...' : value;
                    }
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '',
                position: 'left',
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        type: 'dashed'
                    }
                },
                min: 0
            }
        ],
        series: [
            {
                name: t('c_a_resolve_time'),
                type: 'bar',
                stack: 'resolve',
                barWidth: 34,
                data: list === null || list === void 0 ? void 0 : list.map((item)=>({
                        value: item === null || item === void 0 ? void 0 : item.valueYes,
                        itemStyle: {
                            borderRadius: (item === null || item === void 0 ? void 0 : item.valueNo) === 0 ? [
                                8,
                                8,
                                0,
                                0
                            ] : [
                                0,
                                0,
                                0,
                                0
                            ],
                            color: '#9FE080'
                        }
                    })),
                label: {
                    show: false,
                    position: 'inside',
                    formatter: (params)=>{
                        return params.value === 0 ? '' : params.value;
                    },
                    color: '#FFFFFF'
                }
            },
            {
                name: t('c_a_resolve_one_reception'),
                type: 'bar',
                stack: 'resolve',
                barWidth: 34,
                data: list === null || list === void 0 ? void 0 : list.map((item)=>({
                        value: item === null || item === void 0 ? void 0 : item.valueNo,
                        itemStyle: {
                            borderRadius: [
                                8,
                                8,
                                0,
                                0
                            ],
                            color: '#EE6765'
                        }
                    })),
                label: {
                    show: false,
                    position: 'inside',
                    formatter: (params)=>{
                        return params.value === 0 ? '' : params.value;
                    },
                    color: '#FFFFFF'
                }
            }
        ]
    };
};
